import { render, staticRenderFns } from "./terms_widget.vue?vue&type=template&id=c2f63160&scoped=true&lang=pug"
import script from "./terms_widget.vue?vue&type=script&lang=js"
export * from "./terms_widget.vue?vue&type=script&lang=js"
import style0 from "./terms_widget.vue?vue&type=style&index=0&id=c2f63160&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f63160",
  null
  
)

export default component.exports